import { VariableNames } from "../../../../UserInterfaceModule/Constants/VariableNames";
import { ObjectMapExpression } from "../../../Models/ObjectMapExpression";
import { IExpressionEvaluator, IHasExpressionMetadata } from "../../../Models/IExpressionEvaluator";
import { MaybePromise } from "../../../Models/MaybePromise";
import { IExpressionEvaluatorContext } from "../../../Models/IExpressionEvaluatorContext";

export class ObjectMapExpressionEvaluator implements IExpressionEvaluator<ObjectMapExpression>, IHasExpressionMetadata {
    private static _expressionPropertyNames: string[] = ["Object", "Map"];

    get expressionProperties(): string[] {
        return ObjectMapExpressionEvaluator._expressionPropertyNames;
    }

    get type(): string {
        return "ObjectMap";
    }

    evaluate(expression: ObjectMapExpression, context: IExpressionEvaluatorContext): MaybePromise {
        const sourceObject = context.Evaluator.evaluate(expression.Object, context);

        if (sourceObject instanceof Promise) {
            return sourceObject.then((resolvedObject) => this.mapObject(resolvedObject, expression, context));
        }

        return this.mapObject(sourceObject, expression, context);
    }

    private mapObject(sourceObject: any, expression: ObjectMapExpression, context: IExpressionEvaluatorContext): MaybePromise {
        if (!sourceObject) {
            return null;
        }

        // Create a child context with $source variable
        const childContext = context.CreateChild();
        childContext.VariableScope.set(VariableNames.Source, sourceObject);

        // Evaluate the map expression
        const mapResult = context.Evaluator.evaluate(expression.Map, childContext);

        return mapResult;
    }
}
